import * as angular from 'angular';

import { getDebugJS, getWebappRevision } from '@mode/shared/util-js';

export function setupAppModule(app) {
  app.factory('httpErrorHandler', [
    function () {
      let error: any = {};

      return {
        set: function (message, detail) {
          error.message = message;
          error.detail = detail;
        },

        clear: function () {
          error = {};
        },
      };
    },
  ]);

  app.config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.defaults.headers.common['Accept'] = 'application/vnd.mode+json';
      $httpProvider.defaults.headers.common['Webapp-Revision'] = getWebappRevision(document);
    },
  ]);

  app.config([
    '$compileProvider',
    function ($compileProvider) {
      $compileProvider.aHrefSanitizationTrustedUrlList(/^\s*(https?|ftp|mailto|localhost):/);
      $compileProvider.commentDirectivesEnabled(false);
      $compileProvider.cssClassDirectivesEnabled(false);
      if (process.env.NODE_ENV === 'production') {
        $compileProvider.debugInfoEnabled(false);
      }
    },
  ]);

  app.config([
    '$uibTooltipProvider',
    function ($uibTooltipProvider) {
      $uibTooltipProvider.options({
        animation: false,
      });
    },
  ]);

  app.config([
    '$sceDelegateProvider',
    function ($sceDelegateProvider) {
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://assets*.mode.com/**',
        'https://*assets.mode.com/**',
        'https://assets*.modeanalytics.com/**',
        'https://modesandbox.com/**',
        'https://staging.modesandbox.com/**',
        'https://lab.modesandbox.com/**',
        'https://assets*.modesandbox.com/**',
        'http://assets*.modeanalytics.dev:3000/**',
        'http://*modeanalysis.dev:3000/**',
        'http://assets*.goat.farm:3000/**',
        'http://*.goatpen.farm:3000/**',
        'https://app.*.mode.dev:8443/**',
        'https://app-assets.*.mode.dev:8443/**',
        'https://*.modesandbox.dev:8443/**',
      ]);
    },
  ]);

  // Decorate $q with .spread and .resolve methods
  // taken from Thomas Burleson's $QDecorator:
  // https://github.com/ThomasBurleson/angularjs-FlightDashboard
  app.config([
    '$provide',
    function ($provide) {
      const resolveWith = function ($q) {
        return function resolved(val) {
          const deferred = $q.defer();
          deferred.resolve(val);
          return deferred.promise;
        };
      };

      $provide.decorator('$q', [
        '$delegate',
        function ($delegate) {
          if (angular.isUndefined($delegate.spread)) {
            $delegate.spread = function (targetFn, scope) {
              return function () {
                const params = [].concat(arguments[0]);
                targetFn.apply(scope, params);
              };
            };
          }

          if (angular.isUndefined($delegate.resolve)) {
            $delegate.resolve = resolveWith($delegate);
          }
          return $delegate;
        },
      ]);
    },
  ]);
}
